
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';

import { getAllBlogs } from '@store/slices';
import { RootState } from '@share/utils';
import { Loading } from '@share/components';

import { SearchAshevillePlayNewsEvents } from '../search/search-ashevilleplay/search-ashevilleplay-news-events';

import './style.scss';

export function Blogs() {

  const dispatch = useDispatch();

  const blogsStore = useSelector((state: RootState) => state.blogsStore);

  const { blogs, loading, error } = blogsStore;

  useEffect(() => {
    dispatch(getAllBlogs());
  }, []);

  // If no blog found (will redirect, but show something while redirecting)
  if (!blogs?.length && !loading && isEmpty(error)) {
    return null;
  }

  return (
    <div className="blogs-container">
      {loading && (
        <Loading />)}

      <SearchAshevillePlayNewsEvents isBlogsPage={true} />
    </div>
  );
}
